export const ICON_NETFLIX = "https://asset.pickle.plus/ott_logo/icon_netflix.png";
export const ICON_WAVVE = "https://asset.pickle.plus/ott_logo/icon_wavve.png";
export const ICON_WATCHA = "https://asset.pickle.plus/ott_logo/icon_watcha.png";
export const ICON_LAFTEL = "https://asset.pickle.plus/ott_logo/icon_laftel.png";
